import { render, staticRenderFns } from "./MealsTypeCard.vue?vue&type=template&id=066d172f&"
import script from "./MealsTypeCard.vue?vue&type=script&lang=js&"
export * from "./MealsTypeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports